
export const GetAllSessionsByFilter = (locationid) => {

  return $.get('api/Training/GetAllSessionsByFilter?LocationId='+locationid)

}




// WEBPACK FOOTER //
// ./src/components/TrainingCalender/calender.service.js